var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSpeechtopiaDiamond = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 16.9 16.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.3 3.7H5L1.7 7.3l-.1.2v.2l6.7 6.6h.4l6.6-6.6a.3.3 0 000-.4l-3.5-3.4-.2-.1H5.3zm.3.5h2.3L5.6 6.7zm3.5 0h2.3v2.5zm-.6.2L11 7H6zM5 4.6v2.5H2.5zm7 0l2.4 2.5H12zm-9.5 3H5l2.5 5.1zm3.2 0h5.5l-2.7 5.8zm6.1 0h2.6l-5 5.1z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 14a.3.3 0 01-.2.3.3.3 0 01-.3-.3.3.3 0 01.3-.2.3.3 0 01.2.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.6 14c0 .3.3.3.3.3h2.7c.1 0 .2-.1.2-.3 0-.1 0-.2-.2-.2H2.9s-.3 0-.3.2z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 15a.3.3 0 00.3.3.3.3 0 00.2-.2.3.3 0 00-.2-.3.3.3 0 00-.3.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M4.8 15c0 .3-.3.3-.3.3h-1c-.2 0-.3 0-.3-.2s0-.3.2-.3h1.1s.3 0 .3.3z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8 3a.3.3 0 01.3-.4.3.3 0 01.2.3.3.3 0 01-.2.3.3.3 0 01-.3-.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M14.3 3c0-.4-.3-.4-.3-.4h-2.6c-.2 0-.3.2-.3.3 0 .1.1.3.3.3H14s.3 0 .3-.3z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 1.9a.3.3 0 00-.2-.3.3.3 0 00-.3.3.3.3 0 00.3.2.3.3 0 00.2-.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.2 1.9c0-.3.2-.3.2-.3h1c.3 0 .4.1.4.3 0 0-.1.2-.3.2h-1s-.3 0-.3-.2z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 3a.3.3 0 01-.2.2.3.3 0 01-.3-.3.3.3 0 01.3-.3.3.3 0 01.2.3zM8 2a.3.3 0 01-.2.3.3.3 0 01-.3-.3.3.3 0 01.3-.2.3.3 0 01.2.2zm1.6 0a.3.3 0 01-.2.3A.3.3 0 019 2a.3.3 0 01.3-.2.3.3 0 01.2.2zM2.1 9a.3.3 0 01-.2.3.3.3 0 01-.3-.3.3.3 0 01.3-.3.3.3 0 01.2.3zm13.2 0a.3.3 0 01-.2.3.3.3 0 01-.3-.3.3.3 0 01.3-.3.3.3 0 01.2.3zM2.1 5.8a.3.3 0 01-.2.3.3.3 0 01-.3-.3.3.3 0 01.3-.2.3.3 0 01.2.2zm13.2 0a.3.3 0 01-.2.3.3.3 0 01-.3-.3.3.3 0 01.3-.2.3.3 0 01.2.2zM4.8 3.2a.3.3 0 01-.3.2.3.3 0 01-.3-.2.3.3 0 01.3-.3.3.3 0 01.3.3zm0 8.4a.3.3 0 01-.3.3.3.3 0 01-.3-.3.3.3 0 01.3-.2.3.3 0 01.3.2zm7.9 0a.3.3 0 01-.3.3.3.3 0 01-.2-.3.3.3 0 01.2-.2.3.3 0 01.3.2zm-4 3.5a.3.3 0 01-.2.2.3.3 0 01-.3-.2.3.3 0 01.3-.3.3.3 0 01.2.3z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpeechtopiaDiamond, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/speechtopia-diamond.c1607af8.svg";
export { ForwardRef as ReactComponent };